export const ParticleField = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      {/* Simple gradient background - always rendered, visible on mobile only via CSS */}
      <div className="absolute inset-0 bg-gradient-to-b from-neon-glow/5 to-transparent md:hidden" />
      
      {/* Desktop elements - hidden on mobile via CSS to avoid layout shifts from JS detection */}
      <div className="hidden md:block">
        {/* Simplified Glowing Orbs - reduced blur for performance */}
        <div 
          className="absolute top-10 right-10 w-64 h-64 bg-neon-glow/15 rounded-full"
          style={{ 
            filter: "blur(60px)",
            transform: "translateZ(0)" // GPU acceleration
          }}
        />
        <div 
          className="absolute bottom-20 left-20 w-80 h-80 bg-radiant-blue/10 rounded-full"
          style={{ 
            filter: "blur(80px)",
            transform: "translateZ(0)"
          }}
        />
        
        {/* Reduced particles - only 2 static ones */}
        <div
          className="absolute w-1 h-1 rounded-full bg-neon-glow/40"
          style={{
            left: "20%",
            top: "30%",
            transform: "translateZ(0)"
          }}
        />
        <div
          className="absolute w-1 h-1 rounded-full bg-neon-glow/30"
          style={{
            left: "70%",
            top: "60%",
            transform: "translateZ(0)"
          }}
        />

        {/* Single static geometric shape */}
        <div 
          className="absolute top-1/4 right-1/4 w-24 h-24 border border-neon-glow/20 rotate-45"
          style={{ transform: "rotate(45deg) translateZ(0)" }}
        />
      </div>
    </div>
  );
};
